import { env } from "@/env";
import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";
import { z } from "zod/v4";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function currentEnvironment(): "Live" | "Sandbox" | "Integration" {
  if (env.VITE_VOLUME_URL.includes("sandbox.")) {
    return "Sandbox";
  } else if (env.VITE_VOLUME_URL.includes("integration.")) {
    return "Integration";
  } else {
    return "Live";
  }
}

import { getCurrencySymbol as getCurrencySymbolFromCurrencies } from "@/lib/currencies";

export const getCurrencySymbol = getCurrencySymbolFromCurrencies;

export const numberToDecimalWithCurrency = (
  number: number,
  currency: string,
) => {
  const symbol = getCurrencySymbol(currency);
  const formattedNumber = new Intl.NumberFormat("en-GB", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(number);
  return `${symbol}${formattedNumber}`;
};
export const numberToDecimal = (number: number) => {
  return new Intl.NumberFormat("en-GB", {
    minimumFractionDigits: 2,
  }).format(number);
};

export function camelCaseToTitleCase(str: string) {
  return str
    .replace(/([A-Z])/g, " $1")
    .replace(/_/g, " ")
    .replace(/([0-9])/g, " $1") // Add space before numbers
    .replace(/\b\w/g, (char) => char.toUpperCase())
    .trim();
}

export const COMMON_FETCH_HEADERS = {
  "x-caller-type": "merchant_portal",
  "x-volume-version": import.meta.env.VITE_VERCEL_GIT_COMMIT_SHA ?? "local",
} as const;

// export const FORGOT_PASSWORD_ERROR = {
//   EXPIRED: "EXPIRED",
// };

export const FORGOT_PASSWORD_ERROR_RAW = z.enum(["EXPIRED"]);
export const FORGOT_PASSWORD_ERROR = FORGOT_PASSWORD_ERROR_RAW.enum;

export const datadogEnvironment = () => {
  const envvironmentUrl = env.VITE_VOLUME_URL;
  switch (envvironmentUrl) {
    case "https://api.sandbox.volumepay.io":
      return "sandbox";
    case "https://api.volumepay.io":
      return "live";
    case "https://api.integration.volumepay.io":
    default:
      return "integration";
  }
};
export const DATADOG_SERVICE = "merchant-portal-spa";
export const DATADOG_SITE = "datadoghq.eu";
